import axiosInstance from "../utils/api";

import endpoints from '../constants/endpoints';



export const generateCouponCodes = async (couponData) => {
    try {
        const response = await axiosInstance.post(endpoints.generate_coupon_codes, couponData);
        return response.data;
    } catch (error) {
        console.error('Error generating coupon codes:', error);
        throw error;
    }
};

export const bulkCreateCouponCodes = async (couponData) => {
    try {
        const response = await axiosInstance.post(endpoints.bulk_create_coupon_codes, couponData);
        return response.data;
    }
    catch (error) {
        console.error('Error bulk creating coupon codes:', error);
        throw error;
    }
};


export const fetchCoupons = async (params) => {
    try {
        const queryString = new URLSearchParams(params).toString();
        const response = await axiosInstance.get(endpoints.fetchCoupon(queryString));
        return response.data;
    } catch (error) {
        console.error('Error fetching coupon uses:', error);
        throw error;
    }
};
export const toggleCouponStatus = async (couponId) => {
    try {
        const response = await axiosInstance.post(endpoints.toggleCouponStatus(couponId));
        return response.data;
    }
    catch (error) {
        console.error('Error toggling coupon status:', error);
        throw error;
    }
};


export const deleteCoupon = async (couponId) => {
    try {
        const response = await axiosInstance.delete(endpoints.deleteCoupon(couponId));
        return response.data;
    } catch (error) {
        console.error('Error deleting coupon:', error);
        throw error;
    }   
};


export const createCoupon = async (couponData) => {
    try {
        const response = await axiosInstance.post(endpoints.create_coupon, couponData);
        return response.data;
    } catch (error) {
        console.error('Error creating coupon:', error);
        throw error;
    }   
};

export const updateCoupon = async (couponId, couponData) => {
    try {
        const response = await axiosInstance.put(endpoints.update_coupon(couponId), couponData);
        return response.data;
    } catch (error) {
        console.error('Error updating coupon:', error);
        throw error;
    }
};


export const fetchCouponAnalytics = async (period) => {
  const response = await axiosInstance.get(`${endpoints.fetchCouponAnalytics}?period=${period}`);
  return response.data;
};

export const fetchMostUsedCoupons = async () => {
  const response = await axiosInstance.get(endpoints.fetchMostUsedCoupons);
  return response.data;
};

export const downloadCouponReport = async (startDate, endDate) => {
  const response = await axiosInstance.get(
    endpoints.downloadCouponCustomReport(startDate, endDate),
    { responseType: 'blob' }
  );
  return response.data;
};


export const fetchCouponDashboardStats = async () => {
  const response = await axiosInstance.get(endpoints.fetchCouponAnalytics);
  return response.data;
};

export const fetchExpiringCoupons = async (days = 7) => {
  const response = await axiosInstance.get(`${endpoints.fetchExpiringCoupons}?days=${days}`);
  return response.data;
};

export const fetchRecentCouponUsage = async (page_size = 5) => {
  const response = await axiosInstance.get(`${endpoints.fetchRecentCouponUsage}?page_size=${page_size}`);
  return response.data;
};

export const fetchExpiringCouponsForClient = async ()=>{
    const response = await axiosInstance.get(endpoints.fetchDueDateReachedCoupons);
    return response.data;
}

export const  fetchAvailableCouponsForCustomBasedOnOrderAmount= async (amount) => {
    const response = await axiosInstance.get(endpoints.fetchAvailableCouponsForCustomOrderAmount(amount));
    return response.data;
};


export const fetchCouponForFeaturedDeals = async () => {
    const response = await axiosInstance.get(endpoints.fetchCouponForFeaturedDeals);
    return response.data;
}

export const fetchCouponForFirstTimeCustomer = async () => {
    const response = await axiosInstance.get(endpoints.fetchCouponForFirstTimeCustomer);
    return response.data;
}

export const fetchClientCouponUsageHistory = async () => {
    const response = await axiosInstance.get(endpoints.fetchClientCouponUsageHistory);
    return response.data;
};


export const fetchClientCouponForSpecificCategory = async (categoryId) => {
    const response = await axiosInstance.get(endpoints.fetchClientCouponForCategory(categoryId));
    return response.data;
}
